import React from 'react'
import type { WorkflowNodeData } from '@/types/workflow'
import { Select } from '@/components/ui/Select'
import { Field } from '@/components/ui/Field'

interface ExitWorkflowConfigProps {
  data: WorkflowNodeData
  updateField: (field: string, value: any) => void
}

import { inputClass, inputStyle, sectionClass, warnBannerClass } from './_kit'

const REASON_OPTIONS = [
  { value: 'unsubscribed', label: 'Unsubscribed' },
  { value: 'converted', label: 'Converted' },
  { value: 'disqualified', label: 'Disqualified' },
  { value: 'wrong_persona', label: 'Wrong Persona' },
  { value: 'custom', label: 'Custom' },
]

const LEAD_STATUS_OPTIONS = [
  { value: '', label: "Don't change" },
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'engaged', label: 'Engaged' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'unqualified', label: 'Unqualified' },
]

const ExitWorkflowConfig: React.FC<ExitWorkflowConfigProps> = ({ data, updateField }) => {
  const config = data.exit_workflow_config || { reason: 'converted' }
  const updateConfig = (key: string, value: any) => {
    updateField('exit_workflow_config', { ...config, [key]: value })
  }

  return (
    <div className={sectionClass}>
      <Field label="Label">
        {(f) => (
          <input
            {...f}
            type="text"
            value={data.label || ''}
            onChange={(e) => updateField('label', e.target.value)}
            placeholder="Exit Workflow"
            className={inputClass} style={inputStyle}
          />
        )}
      </Field>

      <Field label="Reason">
        {(f) => (
          <Select
            {...f}
            value={config.reason || 'converted'}
            onChange={(value) => updateConfig('reason', value)}
            options={REASON_OPTIONS}
            className="w-full"
          />
        )}
      </Field>

      {config.reason === 'custom' && (
        <Field label="Custom Reason">
          {(f) => (
            <input
              {...f}
              type="text"
              value={config.custom_reason || ''}
              onChange={(e) => updateConfig('custom_reason', e.target.value)}
              placeholder="Enter custom reason"
              className={inputClass} style={inputStyle}
            />
          )}
        </Field>
      )}

      <Field label="Update Lead Status">
        {(f) => (
          <Select
            {...f}
            value={config.update_lead_status || ''}
            onChange={(value) => updateConfig('update_lead_status', value)}
            options={LEAD_STATUS_OPTIONS}
            className="w-full"
          />
        )}
      </Field>

      <Field label="Add Tag">
        {(f) => (
          <input
            {...f}
            type="text"
            value={config.add_tag || ''}
            onChange={(e) => updateConfig('add_tag', e.target.value)}
            placeholder="e.g., exited_workflow"
            className={inputClass} style={inputStyle}
          />
        )}
      </Field>

      <div className={warnBannerClass}>
        <p className="text-xs">
          This node stops all further workflow processing for the contact.
        </p>
      </div>
    </div>
  )
}

export default ExitWorkflowConfig
